import { Box, Link, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BoletiaLogo } from './BoletiaLogo';
import Image from './Image';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import dayjs from 'dayjs';

const YEAR = dayjs().year();

function BoletiaMobileFooter({ hasTickets }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { termsAndConditions, shoppingTerms, noticeOfPrivacy, help } =
    useAnalyticsEvents();

  return (
    <>
      <Box
        sx={{
          width: '100%',
          background:
            'linear-gradient(70deg, rgba(0,0,232,1) 0%, rgba(237,21,56,1) 70%, rgba(249,81,44,1) 100%)',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          position: 'relative',
        }}
      >
        <Stack
          sx={{
            width: '100%',
            height: '100%',
            backdropFilter: 'blur(200px)',
            color: theme.palette.grey[0],
          }}
          alignItems="center"
          spacing={2}
        >
          <Stack
            gap={3}
            sx={{ width: '100%', padding: '32px 24px' }}
            spacing={0}
          >
            <Box>
              <Image
                sx={{
                  width: '42px',
                  height: '42px',
                }}
                src={BoletiaLogo}
                alt="bolteia logo"
              />
            </Box>
            <Stack gap={2}>
              <Box>
                <Link
                  href="https://boletia.com/terms-of-service"
                  variant="subtitle2"
                  sx={{ color: theme.palette.grey[0] }}
                  marginX={0.5}
                  onClick={() => {
                    termsAndConditions();
                  }}
                  target="_blank"
                  rel="noopener"
                >
                  {t('checkout.global.terms')}
                </Link>
              </Box>
              <Box>
                <Link
                  href="https://boletia.com/terms-of-purchase"
                  variant="subtitle2"
                  sx={{ color: theme.palette.grey[0] }}
                  marginX={0.5}
                  onClick={() => {
                    shoppingTerms();
                  }}
                  target="_blank"
                  rel="noopener"
                >
                  {t('checkout.global.termsPurchase')}
                </Link>
              </Box>

              <Box>
                <Link
                  href="https://boletia.com/aviso-de-privacidad"
                  variant="subtitle2"
                  sx={{ color: theme.palette.grey[0] }}
                  marginX={0.5}
                  onClick={() => {
                    noticeOfPrivacy();
                  }}
                  target="_blank"
                  rel="noopener"
                >
                  {t('checkout.global.privacyNotice')}
                </Link>
              </Box>

              <Box>
                <Link
                  href="https://help.boletia.com/hc/es-419/categories/12339457958541-Soy-asistente-de-un-evento-"
                  variant="subtitle2"
                  sx={{ color: theme.palette.grey[0] }}
                  marginX={0.5}
                  onClick={() => {
                    help();
                  }}
                  target="_blank"
                  rel="noopener"
                >
                  {t('checkout.global.needHelp')}
                </Link>
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          width: '100%',
          height: '98px',
          backgroundColor: (theme) => theme.palette.grey[900],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ textAlign: 'center', color: '#FFFFFF' }}
        >
          {t('checkout.global.madeIn', { year: YEAR })}
        </Typography>
      </Box>
      {hasTickets && <Box sx={{ height: '80px' }} />}
    </>
  );
}

export default BoletiaMobileFooter;
